export var responsiveBreakpointsHome = {
    Small: {
        width: 296,
        height: 300,
        maxWidth: 296,
        minWidth: 296,
    },
    Medium: {
        width: 456,
        height: 300,
        maxWidth: 456,
        minWidth: 297,
    },
    Large: {
        width: 378,
        height: 300,
        maxWidth: 611,
        minWidth: 296,
    },
    ExtraLarge: {
        width: 359.33,
        height: 300,
        maxWidth: 453.5,
        minWidth: 296,
    },
    ExtraExtraLarge: {
        width: 403,
        height: 300,
        maxWidth: 403,
        minWidth: 296,
    },
    ExtraExtraExtraLarge: {
        width: 403,
        height: 300,
        maxWidth: 403,
        minWidth: 403,
    },
};
//# sourceMappingURL=responsive.js.map